var map = {
	"./1.jpg": "2421",
	"./2.jpg": "8833",
	"./3.jpg": "0926",
	"./4.jpg": "98ac",
	"./benefits_eng.jpg": "e20a",
	"./benefits_srb.jpg": "8385",
	"./specif_eng.jpg": "53d1",
	"./specif_srb.jpg": "6822"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5813";